<template>
  <fieldset class="scheduler-border">
    <legend class="scheduler-border">
      {{ title }}
    </legend>
    <slot />
  </fieldset>
</template>

<script>
export default {
  name: 'Fieldset',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
}
</script>

<style>
fieldset.scheduler-border {
  border: 1px solid #dee2e6 !important;
  padding: 0 1.4em 1.4em 1.4em !important;
  margin: 0 0 1.5em 0 !important;
  -webkit-box-shadow:  0 0 0 0 #000;
  box-shadow:  0 0 0 0 #000;
}

legend.scheduler-border {
  font-size: 1.1em !important;
  font-weight: bold !important;
  text-align: left !important;
  width:auto;
  padding:0 10px;
  border-bottom:none;
  color: #6e6b7b;
}
</style>
